import React from 'react'
import { string, func, bool } from 'prop-types'
import { Form, Button } from '@cobalt/cobalt-react-components'
import ActionButton from '../ActionButton'
import {
  PASSWORD_CHANGE_TITLE,
  CURRENT_PASSWORD
} from '../../constants/ui.labels'
import PasswordChangeFieldGroup from '../PasswordChangeFieldGroup'
import PasswordInputFieldGroup from '../PasswordInputFieldGroup'

export default class ChangePasswordForm extends React.PureComponent {
  static propTypes = {
    onSubmit: func.isRequired,
    onFormChange: func.isRequired,
    disabledForm: bool.isRequired,
    oldPassword: string.isRequired,
    password: string.isRequired,
    passwordConfirmation: string.isRequired,
    isValid: bool.isRequired
  }

  static defaultProps = {
    disabledForm: false
  }

  handleOldPasswordChange = event => {
    const oldPassword = event.target.value

    this.props.onFormChange({
      oldPassword
    })
  }

  render() {
    const {
      disabledForm,
      onSubmit,
      oldPassword,
      password,
      passwordConfirmation,
      isValid,
      onFormChange
    } = this.props
    const isSubmitDisabled = disabledForm || !isValid
    return (
      <Form>
        <PasswordInputFieldGroup
          label={CURRENT_PASSWORD}
          disabledForm={disabledForm}
          placeholder={CURRENT_PASSWORD}
          password={oldPassword}
          onPasswordChange={this.handleOldPasswordChange}
          autoFocus
        />
        <PasswordChangeFieldGroup
          formData={{ password, passwordConfirmation }}
          onFormChange={onFormChange}
          disabledForm={disabledForm}
        />
        <ActionButton
          type={Button.SUBMIT_TYPE}
          isProcessing={disabledForm}
          isDisabled={isSubmitDisabled}
          onClick={onSubmit}
          primary
          fullWidth
        >
          {PASSWORD_CHANGE_TITLE}
        </ActionButton>
      </Form>
    )
  }
}
